// Color mapping for event types
export interface EventTypeColorMapping {
  hex: string;
  mui: "default" | "success" | "error" | "warning" | "info";
}

export const EVENT_TYPE_COLORS: Record<string, EventTypeColorMapping> = {
  TRANSACTION_CREATED: {
    hex: "#3388ff", // Blue - default
    mui: "default",
  },
  DELIVERED: {
    hex: "#28a745", // Green
    mui: "success",
  },
  REFUSED: {
    hex: "#fd7e14", // Orange
    mui: "warning",
  },
  AWAITING_ADDRESS_CONFIRMATION: {
    hex: "#ffc107", // Yellow
    mui: "warning",
  },
  DELIVERY_FAILURE: {
    hex: "#dc3545", // Red
    mui: "error",
  },
  STOLEN: {
    hex: "#dc3545", // Red
    mui: "error",
  },
  CUSTOMER_REFUSED: {
    hex: "#fd7e14", // Orange
    mui: "warning",
  },
};

/**
 * Get the hex color for an event type
 */
export const getEventTypeHexColor = (eventType: string): string => {

  const normalizedEventType = eventType.toUpperCase();

  return EVENT_TYPE_COLORS[normalizedEventType]?.hex || "#3388ff"; // Default blue
};

/**
 * Get the Material-UI color for an event type
 */
export const getEventTypeMuiColor = (
  eventType: string
): "default" | "success" | "error" | "warning" | "info" => {
  return EVENT_TYPE_COLORS[eventType]?.mui || "default";
};
